<template>
    <div class="row">
        <div class="col-xl-5 col-lg-6">
            <div class="col-xl-12">
                <order-card :order="order"></order-card>
            </div>
            <div class="col-xl-12">
                <order-items :orderItems="items"></order-items>
                <div class="card">
                    <div class="card-header">
                        <h5 class="card-title">Order Costs ($)</h5>
                    </div>
                    <div class="card-body">
                        <table class="table table-sm">
                            <tbody>
                                <tr>
                                    <th scope="row">Subtotal</th>
                                    <td>${{ Big(order[ORDERS.fields.subtotal]).toFixed(2) }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Delivery Fee</th>
                                    <td>${{ Big(order[ORDERS.fields.deliveryFee]).toFixed(2) }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Admin Fee</th>
                                    <td>${{ Big(order[ORDERS.fields.adminFee]).toFixed(2) }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Tax</th>
                                    <td>${{ Big(order[ORDERS.fields.tax]).toFixed(2) }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Total</th>
                                    <td>${{ Big(order[ORDERS.fields.total]).toFixed(2) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-7 col-lg-6">
            <p-button :class="store ? 'active' : null" type="info" size="sm" @click="setStore">
                Store
            </p-button>
            <p-button :class="courier ? 'active' : null" type="info" size="sm" @click="setCourier">
                Courier
            </p-button>
            <p-button :class="steps ? 'active' : null" type="info" size="sm" @click="setSteps">
                Order Steps
            </p-button>
            <p-button :class="transactions ? 'active' : null" type="info" size="sm" @click="setTransactions">
                Order Transactions
            </p-button>
            <p-button :class="messages ? 'active' : null" type="info" size="sm" @click="setMessages">
                Order Messages
            </p-button>
            <p-button :class="routes ? 'active' : null" type="info" size="sm" @click="setRoutes">
                Routes
            </p-button>
            <order-store v-if="store" :storeId="order[ORDERS.fields.storeId]"></order-store>
            <order-courier v-if="courier" :courierId="order[ORDERS.fields.courierId]"></order-courier>
            <order-steps v-if="steps" :orderSteps="order[ORDERS.fields.orderStep]"></order-steps>
            <order-transactions v-if="transactions"></order-transactions>
            <order-messages v-if="messages"></order-messages>
            <order-routes
                v-if="routes && order && order[ORDERS.fields.courierId]"
                :courierId="order[ORDERS.fields.courierId]"
                :orderRouteId="order[ORDERS.fields.routeId]"
            ></order-routes>
        </div>
    </div>
</template>
<script>
import { Big } from 'big.js'
import { firebaseObjectToArray } from '@/utils'
import { ORDERS } from 'db'
import { ORDER_ACTIONS } from '@/utils/constants'
import OrderCard from 'Shared/Cards/OrderCard'
import OrderItems from 'Shared/OrderItems/OrderItems'
import OrderSteps from './OrderSteps'
import OrderCourier from './OrderCourier'
import OrderStore from './OrderStore'
import OrderTransactions from './OrderTransactions'
import OrderMessages from './OrderMessages'
import OrderRoutes from './OrderRoutes'
export default {
    components: {
        OrderCard,
        OrderItems,
        OrderSteps,
        OrderStore,
        OrderTransactions,
        OrderMessages,
        OrderCourier,
        OrderRoutes
    },
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            Big,
            ORDER_ACTIONS,
            ORDERS,
            store: false,
            courier: false,
            steps: true,
            transactions: false,
            messages: false,
            routes: false
        }
    },
    computed: {
        items() {
            return firebaseObjectToArray(this.order[ORDERS.fields.items])
        }
    },
    methods: {
        closeAll() {
            this.store = false
            this.courier = false
            this.steps = false
            this.transactions = false
            this.messages = false
            this.routes = false
        },
        setStore() {
            this.closeAll()
            this.store = true
        },
        setCourier() {
            this.closeAll()
            this.courier = true
        },
        setSteps() {
            this.closeAll()
            this.steps = true
        },
        setTransactions() {
            this.closeAll()
            this.transactions = true
        },
        setMessages() {
            this.closeAll()
            this.messages = true
        },
        setRoutes() {
            this.closeAll()
            this.routes = true
        }
    }
}
</script>
